import styled from 'styled-components'

export const ButtonBox = styled.div`
  width: 100%;
  display: flex;
  flex-direction: row;
  justify-content: space-between;
  margin-top: 20px;
  gap: 10px;
  @media (max-width: 768px) {
    max-width: 100%;
    position: fixed;
    bottom: 0;
    left: 0;
    padding: 0 10px;
  }
`
export const RollBack = styled.div`
  width: 100%;
  background-color: #fff;
  @media (max-width: 768px) {
    max-width: 100%;
    margin-bottom: 16px;
  }
`
export const Advance = styled.div`
  width: 100%;
  @media (max-width: 768px) {
    max-width: 100%;
    margin-bottom: 16px;
  }
`
